import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let showTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * buyers.length));
      setMinutesAgo(1 + Math.floor(Math.random() * 14));
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        showTimer = window.setTimeout(show, GAP);
      }, VISIBLE_FOR);
    };
    showTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(showTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:right-auto" aria-live="polite" data-id="element-252" data-mp="117fr24c0fxse">
      <AnimatePresence data-id="element-253" data-mp="1fw24g0i2ufgz">
        {visible && !dismissed && <motion.div key={`${buyer.name}-${minutesAgo}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-2 shadow-[0_12px_32px_rgba(5,11,24,0.25)] ring-1 ring-slate-200" data-id="element-254" data-mp="1fxmzdr8b00fd">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy-900 text-2xl" aria-hidden="true" data-id="element-255" data-mp="s8kkgr520lok">
              {buyer.flag}
            </span>
            <div className="min-w-0 flex-1" data-id="element-256" data-mp="23l3j45hi6mup">
              <p className="text-[14px] leading-snug text-ink" data-id="element-257" data-mp="2aotgq36xhdde">
                <strong data-id="element-258" data-mp="2aqnt2t44vx5v">{buyer.name}</strong> from <strong data-id="element-259" data-mp="2fn4u2nwfm60d">{buyer.country}</strong> just purchased{' '}
                <span className="font-semibold text-electric-600" data-id="element-260" data-mp="2fpqxcbcahzcs">TCM Diagnostic Blueprint™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[12px] text-muted" data-id="element-261" data-mp="2pltzhh755xzq">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-cta-600" aria-hidden="true" data-id="element-262" data-mp="2pjhmlig8qdtj" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-muted transition-colors duration-150 ease-out hover:bg-canvas hover:text-ink" aria-label="Dismiss notification" data-id="element-263" data-mp="1wxg3f6zm5bqt">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-264" data-mp="1e6oxkfeu43h6" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}